import {Component, OnInit, forwardRef, Input, Output, EventEmitter} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { DatepickerOptions, NgDatepickerComponent } from 'ng2-datepicker';
import { differenceInDays, format } from 'date-fns';
import { TagInputComponent } from 'ngx-chips';
import * as locale from 'date-fns/locale/es';
import * as es from 'date-fns/locale/es';

const locales = { es };
const placeholders = {
  es: 'Selecciona fecha'
};
const defaultFormat = {
  es: 'D/MM/YYYY'
};

@Component({
  selector: 'bidi-html-editor',
  templateUrl: './html-editor.component.html',
  styleUrls: ['./html-editor.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => HtmlEditorComponent),
    multi: true
  }]
})

export class HtmlEditorComponent implements OnInit, ControlValueAccessor {
  @Output() close = new EventEmitter();
  @Output() saveValue = new EventEmitter();
  @Output() newTheme = new EventEmitter();
  @Input() themes;
  themeSelect: any;
  startDate: any;
  endDate: any;
  finalOptions: DatepickerOptions;
  theme: any;
  title = '';
  abstract = '';
  msgErr = '';
  msgErrData = '';
  duration = 0;
  tagsCustom = [];
  public Editor = ClassicEditor;
  public value = '';
  public config = {
    toolbar: ['heading', '|', 'bold', 'italic', '|', 'undo', 'redo'],
    heading: {
      options: [
        { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
        { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
        { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' }
      ]
    }
  };

  private defaultOptions: DatepickerOptions = {
    barTitleFormat: 'MMMM YYYY',
    dayNamesFormat: 'dd',
    firstCalendarDay: 1,
    addClass: 'input',
    useEmptyBarTitle: false
  };

  /**
   * Invoked when the model has been changed
   */
  onChange: (_: any) => void = (_: any) => {
  };

  /**
   * Invoked when the model has been touched
   */
  onTouched: () => void = () => {
  };

  constructor() {
  }

  ngOnInit() {
    this.finalOptions = Object.assign(
      {
        displayFormat: defaultFormat['es'],
        locale: locales['es'],
        placeholder: placeholders['es']
      },
      this.defaultOptions,
      {}
      // this.options
    );
  }

  /**
   * Method that is invoked on an update of a model.
   */
  updateChanges() {
    this.onChange(this.value);
  }

  /**
   * Writes a new item to the element.
   * @param value the value
   */
  writeValue(value: string): void {
    this.value = value;
    this.updateChanges();
  }

  /**
   * Registers a callback function that should be called when the control's value changes in the UI.
   * @param fn
   */
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  /**
   * Registers a callback function that should be called when the control receives a blur event.
   * @param fn
   */
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  save() {
    const tagsCustom = this.tagsCustom.map(name => ({ name, type: 'manual' }));
    const flagDate = this.operatorDates(this.startDate, this.endDate);
    const flagData = this.validData();
    if (flagDate && flagData) {
      const data = {
        'title': this.title,
        'abstract': this.abstract,
        'tags': tagsCustom,
        'startDate': this.startDate,
        'theme': this.theme,
        'duration': this.duration,
        'html': this.value
      };
      this.saveValue.emit(data);
    }
  }

  validData () {
    let flag = true;
    if (!this.title || !this.value || !this.startDate || !this.theme || !this.endDate) {
      flag = false;
      this.msgErrData = 'Debes completar todos los campos para la creaciÃ³n del contenido';
    }
    return flag;
  }
  operatorDates(start, end) {
    let flag = true;
    this.msgErr = '';
    const startDate = format(start, 'YYYY-MM-DD');
    const endDate = format(end, 'YYYY-MM-DD');
    this.duration = differenceInDays(endDate, startDate);
    if (this.duration < 0) {
      flag = false;
      this.msgErr = 'la fecha de vencimiento no puede ser inferior a la fecha de disponibilidad';
    } else if (this.duration === 0 || this.duration === -0) {
      this.duration = 1;
    }
    return flag;
  }

  selectThemeForContent(t) {
    this.theme = t;
  }

}
